export const statPropMap = {
	totalRevenue: {
		bgColor: 'rgb(99,205,218, 0.2)',
		color: 'rgb(99,205,218)',
		tooltipLabel: 'The total earnings generated from all referrals',
		label: 'Revenue',
		yFormat: ' >-$,.2f',
	},
	totalConversions: {
		bgColor: 'rgb(248,165,194, 0.2)',
		color: 'rgb(248,165,194)',
		tooltipLabel:
			"Counts the number of purchases or qualifying actions taken from an influencer's invite link",
		label: 'Referrals',
		yFormat: ' >-,',
	},
	totalInvitesClicked: {
		bgColor: 'rgb(243,166,131, 0.2)',
		color: 'rgb(243,166,131)',
		tooltipLabel:
			"Tracks the number of times individuals click on an influencer's invite link",
		label: 'Invites Clicked',
		yFormat: ' >-,',
	},
	totalInfluencers: {
		bgColor: 'rgb(162,210,143, 0.2)',
		color: 'rgb(162,210,143)',
		tooltipLabel:
			'Tallies the number of influencers created for your campaigns',
		label: 'Created Influencers',
		yFormat: ' >-,',
	},
	totalUtilizedInfluencers: {
		bgColor: 'rgb(245,205,121, 0.2)',
		color: 'rgb(245,205,121)',
		tooltipLabel:
			'The count of influencers who have successfully prompted at least one click on their invites',
		label: 'Utilized Influencers',
		yFormat: ' >-,',
	},
	totalUtilizationRate: {
		bgColor: 'rgb(189,169,234, 0.2)',
		color: 'rgb(189,169,234)',
		tooltipLabel:
			'The percentage of created influencers who have generated invite clicks',
		label: 'Utilization Rate',
		yFormat: ' >-.2%',
	},
} as const;
